import React, { useState, useEffect } from "react";
import Select from "react-select";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { ModalForm } from "../../../App/components/shared/Modals";
import fetch_backend from "../../../App/components/shared/Fetch";
import { useDataLayerValue } from "../../../App/reducer/DataLayer";
import { useCookies } from "react-cookie";
import _ from "lodash";

// import "./Modals.css";

function ModalDevolucion({ open, onClose, initValuesModalDevolucion, isMultipleReturn }) {
  const init_form_values = {
    fecha_devolucion: "",
    hora_devolucion: "",
    observaciones: "",
    es_funcional: "",
    proximo_mantenimiento: "",
  };

  const [formValues, setFormValues] = useState({
    ...init_form_values,
  });
  const [{ actual_url }, dispatch] = useDataLayerValue();
  const [isLoading, setIsLoading] = useState(false);
  const [openModalForm, setOpenModalForm] = useState(false);
  const [successModalForm, setSuccessModalForm] = useState(false);
  const [messageModalForm, setMessageModalForm] = useState();
  const [cookies] = useCookies();
  const token = cookies.token_inventario;

  const change_input = (event) => {
    var { name, value } = event.target;
    if (name === "es_funcional") {
      value = value === "true";
    }
    let values = { ...formValues };
    values[name] = value;
    setFormValues(values);
  };

  const validate = () => {
    const errors = {};

    // Validación para devoluciones múltiples: no mezclar herramientas en mantenimiento con las que no
    if (isMultipleReturn) {
      const enMantenimiento = initValuesModalDevolucion.filter(item => item.en_mantenimiento);
      const noEnMantenimiento = initValuesModalDevolucion.filter(item => !item.en_mantenimiento);
      
      if (enMantenimiento.length > 0 && noEnMantenimiento.length > 0) {
        const referenciasEnMantenimiento = [...new Set(enMantenimiento.map(item => item.codigo))].join(', ');
        errors.mixed_maintenance = `No se pueden mezclar herramientas en mantenimiento con las que no. Herramientas en mantenimiento: ${referenciasEnMantenimiento}`;
        return errors;
      }
    }

    if (!formValues.fecha_devolucion) {
      errors.fecha_devolucion = 'Falta Seleecionar "Fecha Devolución"';
    }

    if (!formValues.hora_devolucion) {
      errors.hora_devolucion = 'Falta Seleecionar "Hora"';
    }

    if (formValues.es_funcional === "") {
      errors.es_funcional = 'Falta Seleecionar "¿Es funcional?"';
    }

    if (
      formValues.es_funcional === false &&
      formValues.observaciones.trim() === ""
    ) {
      errors.es_funcional = "Por favor diligencie las observaciones";
    }

    // Validar próximo mantenimiento solo si la herramienta estaba en mantenimiento
    if (isMultipleReturn) {
      // Para devoluciones múltiples, verificar si todas están en mantenimiento
      const todasEnMantenimiento = initValuesModalDevolucion.every(item => item.en_mantenimiento);
      if (todasEnMantenimiento && !formValues.proximo_mantenimiento) {
        errors.proximo_mantenimiento = 'Falta Seleccionar "Próximo Mantenimiento"';
      }
    } else {
      // Para devoluciones individuales, verificar si estaba en mantenimiento
      if (initValuesModalDevolucion.en_mantenimiento && !formValues.proximo_mantenimiento) {
        errors.proximo_mantenimiento = 'Falta Seleccionar "Próximo Mantenimiento"';
      }
    }

    return errors;
  };

  const send_request = async () => {
    const errors = validate();

    if (!_.isEmpty(errors)) {
      setSuccessModalForm(false);
      setMessageModalForm(errors);
      setOpenModalForm(true);
      return;
    }

    setIsLoading(true);

    let tools_id = [];

    if (isMultipleReturn) {
      tools_id = initValuesModalDevolucion.map(item => item.codigo);
    } else {
      tools_id = [initValuesModalDevolucion.codigo];
    }

    const payload = {
      fecha_devolucion: formValues.fecha_devolucion,
      hora_devolucion: formValues.hora_devolucion,
      observaciones: formValues.observaciones,
      es_funcional: formValues.es_funcional,
      tools_id: tools_id,
    };

    if (formValues.proximo_mantenimiento) {
      payload.proximo_mantenimiento = formValues.proximo_mantenimiento;
    }
    
    const response = await fetch_backend(
      "tools/returns/",
      "POST",
      token,
      dispatch,
      payload
    );

    if (response.status === 200) {
      onClose(200);
    }
    // Considerar manejo de errores si response.status no es 200
    // Por ejemplo, mostrar un mensaje al usuario.
    
    setIsLoading(false);
  };

  useEffect(() => {
    var values = { ...formValues };
    const today = new Date();
    var date = today.toISOString().slice(0, 10);
    var time = today
      .toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
      .slice(0, 5);
    values.fecha_devolucion = date;
    values.hora_devolucion = time.toString();
    setFormValues(values);
  }, []);

  return (
    <>
      <ModalForm
        open={openModalForm}
        onClose={() => setOpenModalForm(false)}
        successModal={successModalForm}
        messageModal={messageModalForm}
      />
      <Dialog
        onClose={() => onClose()}
        open={open}
        aria-labelledby="simple-dialog-title"
        maxWidth="xs"
        fullWidth={true}
      >
        <DialogTitle id="simple-dialog-title" style={{ margin: "0 auto" }}>
          <h3>Devolución</h3>
        </DialogTitle>
        <DialogContent>
          <p
            style={{ marginBottom: "20px" }}
            className="label_input_modal p_modal_herramientas"
          >
            {isMultipleReturn ? `${initValuesModalDevolucion.length} Herramientas Seleccionadas` : initValuesModalDevolucion.descripcion}
          </p>
          
          <div className="row_modal">
            <div>
              <p
                className="label_input_modal p_modal_herramientas"
                style={{ fontWeight: "bold" }}
              >
                Fecha
              </p>
              <input
                type="date"
                name="fecha_devolucion"
                onChange={(e) => change_input(e)}
                value={formValues?.fecha_devolucion}
              />
            </div>
            <div>
              <p
                className="label_input_modal p_modal_herramientas"
                style={{ fontWeight: "bold" }}
              >
                Hora
              </p>
              <input
                type="time"
                name="hora_devolucion"
                onChange={(e) => change_input(e)}
                value={formValues?.hora_devolucion}
              />
            </div>
          </div>

          {/* Solo mostrar Próximo Mantenimiento si estaba en mantenimiento */}
          {(!isMultipleReturn && initValuesModalDevolucion.en_mantenimiento) || 
           (isMultipleReturn && initValuesModalDevolucion.some(item => item.en_mantenimiento)) ? (
            <div className="row_modal">
              <div>
                <p
                  className="label_input_modal p_modal_herramientas"
                  style={{ fontWeight: "bold" }}
                >
                  Próximo Mantenimiento
                </p>
                <input
                  type="date"
                  name="proximo_mantenimiento"
                  onChange={(e) => change_input(e)}
                  value={formValues.proximo_mantenimiento || ""}
                />
              </div>
              <div />
            </div>
          ) : null}

          {!isMultipleReturn && (
            <div className="row_modal" style={{ marginBottom: "5px" }}>
              <div style={{ flex: 1 }}>
                <p
                  className="label_input_modal p_modal_herramientas"
                  style={{ fontWeight: "normal" }}
                >
                  <span style={{ fontWeight: "bold" }}>
                    Observaciones Salida:{" "}
                  </span>
                  {initValuesModalDevolucion.observaciones_salida}
                </p>
              </div>
            </div>
          )}

          <div className="row_modal">
            <div className="obs_devolucion_container">
              <p
                className="label_input_modal p_modal_herramientas"
                style={{ fontWeight: "bold" }}
              >
                Observaciones
              </p>
              <textarea
                name="observaciones"
                onChange={(e) => change_input(e)}
              />
            </div>
            <div className="es_funcional_devolucion_container">
              <p
                className="label_input_modal p_modal_herramientas"
                style={{ fontWeight: "bold" }}
              >
                ¿Es Funcional?
              </p>
              <div className="simple_flex" style={{ marginTop: "20px" }}>
                <input
                  type="radio"
                  name="es_funcional"
                  value={true}
                  onClick={(e) => change_input(e)}
                />
                <p
                  className="label_input_modal"
                  style={{ fontWeight: "normal", marginLeft: "7px" }}
                >
                  Si
                </p>
              </div>
              <div className="simple_flex" style={{ marginTop: "15px" }}>
                <input
                  type="radio"
                  name="es_funcional"
                  value={false}
                  onClick={(e) => change_input(e)}
                />
                <p
                  className="label_input_modal"
                  style={{ fontWeight: "normal", marginLeft: "7px" }}
                >
                  No
                </p>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            className="btn_cancelar"
            onClick={() => onClose()}
            disabled={isLoading}
          >
            Cancelar
          </button>
          <button
            className="btn_guardar"
            onClick={send_request}
            disabled={isLoading}
          >
            {isLoading ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              "Guardar"
            )}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ModalDevolucion;
